import angular from 'angular';
import {
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  ssListItem,
} from 'app/components/global';
import editProcessSuccessionDialog from './dialog.editProcessSuccessionDialog';
import successor from './successor';
import directive from './bcp-succession-planning.directive';
import controller from './bcp-succession-planning.controller';


export default angular.module('app.components.advisory.bcp.bcpSuccessionPlanning', [
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService,
  userService,
  confirmDialog,
  alerts,
  ssListItem,
  editProcessSuccessionDialog,
  successor,
])
  .directive('bcpSuccessionPlanning', directive)
  .controller('BCPSuccessionPlanningController', controller)
  .name;

console.log('app.components.advisory.bcp.bcpSuccessionPlanning created');
